var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-tabela',{attrs:{"itens":_vm.contrato.penalidades,"campos":_vm.campos,"itensPorPagina":_vm.itensPorPagina,"bordered":false,"small":false},scopedSlots:_vm._u([{key:"valorMulta",fn:function(data){return [_c('p',{staticClass:"text-right m-0"},[_vm._v(_vm._s(_vm._f("currency")(data.valorMulta)))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }